// extracted by mini-css-extract-plugin
export default {"container":"Layouts_container__WARmM","detailInfo":"Layouts_detailInfo__R0386","operationalPanel":"Layouts_operationalPanel__1MPbU","actionButton":"Layouts_actionButton__lL+0n"};